import seedrandom from "seedrandom";

// TODO: mv to colors util.
export function getSeedRandomColor(seed: string): string {
  const random = seedrandom(seed)
  // Math.pow(15, 6) instead of Math.pow(16, 6)
  // attempting to avoid white colors which are the highest values
  let color = `#${Math.floor(random() * Math.pow(15, 6)).toString(16)}` // magic
  // A few colors are invalid with only 5 characters instead of 6
  // This is the case when using Math.pow(16, 6) as well
  return `${color}666`.slice(0, 7)
}

/**
 * Parse various color formats to rgba string
 * Supports: rgba strings, hex colors, named colors, arrays, objects
 */
export function parseRgba(
  color:
    | string
    | number[]
    | { r: number; g: number; b: number; a?: number }
    | null
    | undefined
): string | undefined {
  if (!color) return undefined

  // Handle string colors
  if (typeof color === "string") {
    // If it's already an rgba string, return as is
    if (color.includes("rgba(") || color.includes("rgb(")) {
      return color
    }

    // If it's a hex color, convert to rgba
    if (color.startsWith("#")) {
      const hex = color.replace("#", "")
      const r = parseInt(hex.substr(0, 2), 16)
      const g = parseInt(hex.substr(2, 2), 16)
      const b = parseInt(hex.substr(4, 2), 16)
      return `rgba(${r}, ${g}, ${b}, 1)`
    }

    // If it's a comma-separated string, wrap in rgba()
    if (color.includes(",")) {
      return `rgba(${color})`
    }

    // For named colors, we'll need to handle them differently
    // For now, return as is and let CSS handle it
    return color
  }

  // Handle arrays [r, g, b, a?]
  if (Array.isArray(color)) {
    const [r, g, b, a = 1] = color
    return `rgba(${r}, ${g}, ${b}, ${a})`
  }

  // Handle objects {r, g, b, a?}
  if (typeof color === "object" && color !== null) {
    const { r, g, b, a = 1 } = color
    return `rgba(${r}, ${g}, ${b}, ${a})`
  }

  return undefined
}
